"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiCardActions = function MuiCardActions() {
  return {
    root: {
      padding: 16,
      justifyContent: 'flex-end'
    },
    spacing: {
      '& > :not(:first-child)': {
        marginLeft: 16
      }
    }
  };
};

var _default = MuiCardActions;
exports["default"] = _default;